/**
 * Partner recommendations shown on Learn pages.
 * url: optional — when set, PartnerTip renders a CTA (future affiliate).
 */
export const partners = {
  onePassword: {
    name: '1Password',
    blurb:
      'A password manager stores unique, strong passwords for every account so you are not reusing credentials scammers may already have.',
    url: null,
  },
};

export function getPartner(id) {
  return partners[id] || null;
}
